export const setCall = payload => ({
  type: 'SET_CALL_STATE',
  payload,
});
